import React, { useEffect } from "react";
import '../css/customToggle.css'
import {  AppProperties } from '../common/function';



const CustomToggle = (props) => {
	const appProperties = AppProperties();

  const onClickHandleEnable = () =>{
      props.onEnableChecked()
  }
  const onClickHandleDisable = () =>{
      props.onDisableChecked()
  }
  const onClickHandleRedirect = () => {
	  props.onHandleMiddleredirect()
  }
  return (
	<div   className={appProperties.enableLTI ? "Customtooltip" : "defaultCss"}>
    <div id={props.id} className="tri-state-toggle">
				<button  onClick={onClickHandleEnable} style={{ 
					backgroundColor: props?.syncStatus == 1  && (!props.tristate && props.Enabled)
					? "orange" : props?.syncStatus == 2  && (!props.tristate && props.Enabled)
					 ? 'green' : props?.syncStatus == 3 && (!props.tristate && props.Enabled)
					 ? '#bb0000':"#727C8"}} 
					 
					 className={ (!props.tristate && props.Enabled) ? "tri-state-toggle-button active" : "tri-state-toggle-button"}  >
					On
				</button>

			<div className={props.sourceRedirect && !appProperties.enableLTI  ? "middleCustomTooltip" : ""} >

				<button onClick={onClickHandleRedirect} className={props.tristate ? "tri-state-toggle-button active" : "tri-state-toggle-button"}
				
				style={{ 
					backgroundColor: props?.syncStatus == 1  && (props.tristate == 1 && !props.Enabled)
					? "orange" : props?.syncStatus == 2  && (props.tristate == 1 && !props.Enabled)
					 ? 'green' : props?.syncStatus == 3 && (props.tristate == 1 && !props.Enabled)
					 ? '#bb0000':"#727C8",
					 borderTopWidth: props.tristate == 1 ? '0.9rem':"0"
					}} 
				>
					<div
					style={{
						marginTop:  props.tristate == 1 ? "-13px" : "0px"
					}}
					>
					
					</div>
					{
							props.sourceRedirect && !appProperties.enableLTI ? 
							<span class="middleTootlTip">The synchronization status depends on the source university. Alternatively, click the middle button to be redirected to the source university.</span>
							: " "
					}
				</button>
			</div>

				<button onClick={onClickHandleDisable} className={ (!props.tristate && !props.Enabled) ? "tri-state-toggle-button active" : "tri-state-toggle-button"} >
					Off
				</button>

			{
				appProperties.enableLTI ? 
				<span class="tooltiptext">You are not allowed to make changes here, please visit the OSU core QB to toggle the switches.Alternatively, Click the Middle button to be redirected to the source university.</span>
				: " "
			}
				

	</div>
	</div>
  )
}



export default CustomToggle;
